import React, { useEffect, useState } from "react";
import { CheckCircle2, Inbox } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const dt = (s) => (s ? new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");

export default function EaActivationRequests() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/ea/activation-requests").then(({ data }) => setRows(data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const done = async (id) => {
    try { await api.post(`/ea/activation-requests/${id}/done`); toast.success("Richiesta segnata come gestita"); load(); }
    catch { toast.error("Operazione non riuscita"); }
  };
  const pending = (rows || []).filter((r) => r.status === "pending").length;
  if (!rows?.length) return null;
  return (
    <div className="card-elevated p-5" data-testid="ea-activation-requests">
      <div className="flex items-center gap-2 mb-3">
        <Inbox size={18} className="text-purple-700" />
        <h2 className="font-display text-lg font-bold text-slate-900">Richieste di attivazione</h2>
        {pending > 0 && <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-purple-100 text-purple-700" data-testid="ea-activation-pending-count">{pending} da gestire</span>}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs text-slate-500 bg-slate-50"><tr>{["Data", "Cliente", "Utente", "Messaggio", "Stato", ""].map((h) => <th key={h} className="px-3 py-2 text-left font-semibold">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100 align-top" data-testid={`ea-activation-row-${r.id}`}>
                <td className="px-3 py-2 whitespace-nowrap">{dt(r.created_at)}</td>
                <td className="px-3 py-2 font-semibold">{r.company_name}</td>
                <td className="px-3 py-2">{r.user_name}<div className="text-xs text-slate-500">{r.user_email}</div></td>
                <td className="px-3 py-2 text-slate-600 max-w-sm">{r.message || "—"}</td>
                <td className="px-3 py-2 whitespace-nowrap">{r.status === "pending" ? <span className="text-purple-700 font-semibold">Da gestire</span> : <span className="text-emerald-700">Gestita {dt(r.handled_at)}</span>}</td>
                <td className="px-3 py-2 text-right">{r.status === "pending" && (
                  <button onClick={() => done(r.id)} className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg border border-slate-200 text-xs font-semibold hover:bg-slate-50" data-testid={`ea-activation-done-${r.id}`}><CheckCircle2 size={14} /> Segna gestita</button>)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-xs text-slate-500 mt-3">Per attivare il modulo: Utenti &amp; Aziende → azienda → interruttore "Energy Analytics".</div>
    </div>
  );
}
